import { render, staticRenderFns } from "./LanguagePills.vue?vue&type=template&id=2e6dc52b&scoped=true"
import script from "./LanguagePills.vue?vue&type=script&lang=js"
export * from "./LanguagePills.vue?vue&type=script&lang=js"
import style0 from "./LanguagePills.vue?vue&type=style&index=0&id=2e6dc52b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6dc52b",
  null
  
)

export default component.exports